module.exports = __webpack_public_path__ + "static/media/12.bb976cf8.jpg";